// Lightweight client for POST /api/tax-notes/preview.
// Used by JurisdictionManager to refine locally-generated split-jurisdiction
// notes via the backend (single source of truth path). Always falls back to
// the local engine output on any failure — zero-regression guarantee.

import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Request backend-generated notes for the given jurisdictions.
 * @param {{ jurisdictions: Array, state: string }} params
 * @param {AbortSignal} [signal] optional AbortSignal for debounce cancellation
 * @returns {Promise<{ notes: string, source: 'split_semiannual' | 'split_quarterly' | 'none' }>}
 * @throws on network error, 4xx/5xx, or timeout. Caller must handle and fall
 *         back to the local engine.
 */
export const fetchTaxNotesPreview = async ({ jurisdictions, state }, signal) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${BACKEND_URL}/api/tax-notes/preview`,
    {
      jurisdictions: (jurisdictions || []).map((j) => ({
        jurisdiction_name: j.jurisdiction_name || null,
        collection_frequency: j.collection_frequency || null,
        installments: (j.installments || []).map((inst) => ({
          installment_name: inst.installment_name || null,
          tax_year: inst.tax_year || null,
          pay_status: inst.pay_status || null,
          due_date: inst.due_date || null,
          dlq_date: inst.dlq_date || null,
          paid_date: inst.paid_date || null,
          paid_amount: inst.paid_amount || null,
          balance_amount: inst.balance_amount || null,
          discount_penalty: inst.discount_penalty || null,
        })),
      })),
      state: state || '',
    },
    {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      timeout: 5000,
      signal,
    }
  );
  return response.data;
};
